import 'source-map-support/register';
import Editor from './Editor/Editor';
export { Editor };
export default Editor;